import React, { useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import HomePage from './components/HomePage';
import ConversationUpload from './components/ConversationUpload';
import ConversationList from './components/ConversationList';
import ConversationDetail from './components/ConversationDetail';
import Header from './components/Header';
import { AuthProvider } from './context/AuthContext';
import { ApiKeyProvider } from './context/ApiKeyContext';
import ApiKeyModal from './components/ApiKeyModal';
import ApiKeyRequiredModal from './components/ApiKeyRequiredModal';
import EmailVerificationGate from './components/EmailVerificationGate';
import './App.css';

const queryClient = new QueryClient();

function App() {
  const [activeTab, setActiveTab] = useState<'home' | 'upload' | 'conversations'>('upload');
  const [selectedConversationId, setSelectedConversationId] = useState<string | null>(null);

  const handleViewDetails = (conversationId: string) => {
    setSelectedConversationId(conversationId);
  };

  const handleBackToList = () => {
    setSelectedConversationId(null);
  };

  return (
    <ApiKeyProvider>
      <AuthProvider>
        <EmailVerificationGate>
        <QueryClientProvider client={queryClient}>
          {selectedConversationId ? (
            <ConversationDetail
              conversationId={selectedConversationId}
              onBack={handleBackToList}
            />
          ) : (
            <div className="min-h-screen" style={{
              background: '#000000'
            }}>
              <Header activeTab={activeTab} setActiveTab={setActiveTab} />

              {activeTab === 'home' ? (
                <HomePage />
              ) : activeTab === 'upload' ? (
                <ConversationUpload />
              ) : (
                <main className="container mx-auto px-4 py-8" style={{ paddingTop: '7rem' }}>
                  <div className="max-w-6xl mx-auto">
                    <h2 className="text-3xl font-bold mb-6" style={{
                      color: '#ffffff',
                      letterSpacing: '0.05em',
                      textTransform: 'uppercase',
                      fontFamily: "'Inter', sans-serif"
                    }}>
                      Your Conversations
                    </h2>
                    <ConversationList onViewDetails={handleViewDetails} />
                  </div>
                </main>
              )}
            </div>
          )}
          <ApiKeyModal />
          <ApiKeyRequiredModal />
        </QueryClientProvider>
        </EmailVerificationGate>
      </AuthProvider>
    </ApiKeyProvider>
  );
}

export default App;
